import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { appSettings } from 'app/appSettings';
import { ClearCustomerGuard } from 'app/core/guards/select-customer-clear.resolve';
import { NotSelectedCustomerGuard } from 'app/core/guards/select-customer-not-selected.resolve';
import { SelectCustomerContainer } from './select-customer-container/select-customer.container';

const routes: Routes = [
  {
    path: 'customer/select/clear',
    component: SelectCustomerContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [ClearCustomerGuard],
    },
  },

  {
    path: appSettings.SELECT_CUSTOMER_ROUTE,
    component: SelectCustomerContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [NotSelectedCustomerGuard],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectCustomerRoutingModule {}
